import Vue from 'vue'
import Router from 'vue-router'
import LoanDetails from '../views/loan-request-details'
import Login from '../views/login'
import PasswordReset from '../views/password-reset'
import ForgotPassword from '../views/forgot-password'
import LoanRequests from "../components/LoanRequests";
import auth from "../middleware/auth";
import guest from "../middleware/guest";
import store from "../store";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
            meta: {
                middleware: [guest]
            },
        },
        {
            path: '/loans/:id',
            name: 'loan-request-details',
            component: LoanDetails,
            props: true,
            meta: {
                middleware: [auth]
            }
        },
        {
            path: '/loans',
            name: 'loans',
            component: LoanRequests,
            meta: {
                middleware:[ auth]
            }
        },
        {
            path: '/pin-reset',
            name: 'passwordReset',
            component: PasswordReset,
            meta: {
                middleware: [auth]
            }
        },
        {
            path: '/forgot-password',
            name: 'forgotPassword',
            component: ForgotPassword,
            meta: {
                middleware: [guest]
            }
        }
    ]
});
router.beforeEach((to, from, next) => {
    if (!to.meta.middleware) {
        return next()
    }
    const middleware = to.meta.middleware;
    const context = {
        to,
        from,
        next,
        store
    };
    return middleware[0]({
        ...context
    })
});
export default router
